<template>
  <base-material-card
    color="primary"
    icon="mdi-pencil"
    :title="`Informações Básicas :: ${nomeRelatorioModelo}`"
    inline
    class="px-5 py-3"
  >
    <v-form>
      <v-row>
        <v-col>
          <v-alert
            v-if="descricao"
            dense
            dismissible
            outlined
            type="info"
            color="blue"
            class="icon-right-alert-ib mb-0 px-1 py-0"
          >
            {{ descricao }}
          </v-alert>
        </v-col>
      </v-row>
      <v-row align="center" no-gutters class="ml-0">
        <v-col class="pt-2">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field v-model="nome" outlined :error-messages="errors">
              <template v-slot:label>
                Nome do Relatório
                <obrigatorio />
              </template>
            </v-text-field>
          </validation-provider>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
  export default {
    components: {
      Obrigatorio: () => import('@/components/general/GeneralMarkObrigatorio')
    },

    props: {
      nomeRelatorioModelo: {
        type: String,
        default: ''
      },
      descricao: {
        type: String,
        default: ''
      }
    },

    data: () => ({
      nome: ''
    }),

    methods: {
      exportCampos() {
        return this.nome;
      }
    }
  };
</script>

<style>
  .icon-right-alert-ib button {
    margin-right: 3px !important;
  }
</style>